import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';


class CartDrawerComponent extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }


  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    stopRewardUpdater();
  }


  #handleCartAdd = () => {

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }

    setTimeout(updateRewardBar, 700);

    startRewardUpdater();
  };


  open() {

    this.showDialog();

    updateRewardBar();

    startRewardUpdater();


    customElements.whenDefined('shopify-payment-terms').then(() => {

      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;


      const cta =
        installmentsContent?.querySelector('#shopify-installments-cta');


      cta?.addEventListener(
        'click',
        this.closeDialog,
        { once:true }
      );

    });

  }


  close() {

    this.closeDialog();

    stopRewardUpdater();

  }

}



if (!customElements.get('cart-drawer-component')) {

  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );

}



/* =====================
   REWARD SYSTEM
===================== */


const FIRST_TARGET = 6000;
// const SECOND_TARGET = 12000;


let rewardInterval = null;
let updatingReward = false;



async function getCart() {

  await new Promise(resolve =>
    setTimeout(resolve,700)
  );


  const res =
    await fetch('/cart.js?ts=' + Date.now());


  return await res.json();

}




async function updateRewardBar() {

  // prevent multiple updates together
  if (updatingReward) return;

  updatingReward = true;

  try {

    const cart = await getCart();

    const total =
      (
        cart.items?.reduce(
          (sum, item) =>
            sum + item.final_line_price,
          0
        ) || 0
      ) / 100;

    const bar =
      document.getElementById("reward-progress");

    const text =
      document.getElementById("reward-text");

    let progress = 0;

    /*
      Rs. 6,000+
      Rs. 500 discount
    */

    if (total >= FIRST_TARGET) {

      progress = 100;

      if (text) {
        text.innerHTML = `
          🎉 Rs. 500 OFF has been applied to your order.
        `;
      }

    }

    /*
      Below Rs. 6,000
    */

    else {

      const remaining500 =
        FIRST_TARGET - total;

      progress =
        (total / FIRST_TARGET) * 100;

      progress =
        Math.min(
          Math.max(progress, 0),
          100
        );

      if (text) {
        text.innerHTML = `
          You’re just Rs.
          ${Math.round(remaining500).toLocaleString()}
          away from saving Rs. 500
        `;
      }

    }

    if (bar) {

      bar.style.transition =
        "width .4s ease";

      bar.style.width =
        progress + "%";

    }

  } catch (err) {

    console.error(
      "Reward bar error:",
      err
    );

  } finally {

    updatingReward = false;

  }

}





function startRewardUpdater(){

  if(rewardInterval) return;


  rewardInterval =
  setInterval(
    updateRewardBar,
    8000
  );

}




function stopRewardUpdater(){

  clearInterval(
    rewardInterval
  );


  rewardInterval = null;

}